import { createContext } from 'react';

export const SankeyColumnLabelsContext = createContext<
  Record<number, string> | undefined
>(undefined);

SankeyColumnLabelsContext['displayName'] = 'SankeyColumnLabelsContext';
